import { redirect } from 'next/navigation';

/**
 * @description apiFetch function to handle special error codes from the API.
 * - `response`: *Response* - The response object from the API.
 */
export const specialErrorCodesApiFetch = async (
  response: Response,
) => {
  // Parse the error response
  if (!response.ok) {
    const error = await response.json() as ApiSchema<'ErrorResponse'>;
    const firstError = error?.errors?.[0] ? error.errors[0] : undefined;
    const firstCode = firstError?.code;
    let redirectUrl: string | undefined;

    // Handle special error codes
    switch (firstCode) {
      case 862:
        // Handle 862 error code - Account is blocked for accumulated debts
        redirectUrl = '/account-blocked';
        break;
      default:
        // Not a special error code
        break;
    }

    // Redirect if a URL is defined
    if (redirectUrl) redirect(redirectUrl);
  }
};
